import React from 'react';
import PropTypes from 'prop-types';
import UserStore from '../stores/UserStore';
import { getTranslation } from '../helpers/translationHelper';

export default function AuthController({ rightsPhrase }) {
    const isHaveAccess = UserStore.getAccess();
    const phrase =
        rightsPhrase ||
        getTranslation('auth.rightsPhrase', '');

    if (isHaveAccess) return null;

    return (
        <div className="auth-controller-container">
            <p>{phrase}.</p>
        </div>
    );
}

AuthController.propTypes = {
    rightsPhrase: PropTypes.string,
};
